import { Card, CardContent, Fab, Icon } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { MODULE_EXTRANET_INVOICES } from '../../redux/authorizedApps/authorizedAppsConstants';
import { downloadReactTableAsXlsx, formatAmountToString } from '../../utils';
import CustomizedTextField from '../Input/CustomizedTextField';

class InvoicesCounters extends Component {

    download() {
        if (this.props.invoices.filteredAndSortedInvoices.length <= 0)
            return;

        downloadReactTableAsXlsx(this.props.invoices.filteredAndSortedInvoices, this.props.columns, "Factures")
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin counters-card without-side-padding-only-small-screen">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6 control-margin-top">
                        <div className="center">
                            {this.props.invoices.filteredAndSortedInvoices.length > 0 ? (
                                <Fab variant="extended" type="submit" className="div-center" color="secondary" onClick={this.download.bind(this)}>
                                    <Icon>download</Icon>
                                </Fab>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <CustomizedTextField
                            id="nb-total-invoices"
                            label="Nb factures"
                            className="full_size light-disabled"
                            value={this.props.tableState.nbTotalResults[MODULE_EXTRANET_INVOICES]}
                            margin="normal"
                        />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <CustomizedTextField
                            id="total-untaxed-amount"
                            label="Total HT"
                            className="full_size light-disabled"
                            value={formatAmountToString(this.props.invoices.totalUntaxedAmount)}
                            margin="normal"
                        />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <CustomizedTextField
                            id="total-amount"
                            label="Total TTC"
                            className="full_size light-disabled"
                            value={formatAmountToString(this.props.invoices.totalAmount)}
                            margin="normal"
                        />
                    </div>
                </CardContent>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        invoices: state.invoices,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesCounters);
